var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "list" },
    _vm._l(_vm.upsellModels, function (upsellModel) {
      return _c("UpsellSelectItemView", {
        key: upsellModel.id,
        attrs: {
          "upsell-model": upsellModel,
          "cart-item-model": _vm.cartItemModel(),
          quantity: _vm.quantity,
          "price-label": _vm.priceLabel(upsellModel),
          "product-id": _vm.productId,
          "cart-item-id": _vm.cartItemId,
        },
        on: {
          findCartItemUpsell: _vm.findCartItemUpsell,
          handleCartItemUpsell: _vm.handleCartItemUpsell,
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }